module.exports = __webpack_public_path__ + "static/img/tx3.fbfe5f06.png";